import "./styles/global.scss";
import React, { useEffect, useState } from "react";
import AppRoutes from "./core/router/AppRoutes";
import { useAuth } from "features/auth/hooks/useAuth";
import SplashScreen from "components/Splash";

const App: React.FC = () => {
  const { isLoading } = useAuth();
  const [showSplash, setShowSplash] = useState(true);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    if (!isLoading) {
      setFadeOut(true);

      const timeout = setTimeout(() => setShowSplash(false), 600);
      return () => clearTimeout(timeout);
    }
  }, [isLoading]);

  return (
    <>
      {showSplash && <SplashScreen fadeOut={fadeOut} />}

      {!isLoading && <AppRoutes />}
    </>
  );
};

export default App;
